<template>
	<div class="edit-admin-profile">
		<div class="vx-row">
			<div class="vx-col w-full xl:w-3/4 mb-5">
				<vx-card>
					<h1 class="text-center sm:text-left">
						{{ $t("profileEditing") }}
					</h1>
					<div
						class="row d-flex flex-col sm:flex-row items-center sm:items-start"
					>
						<ProfileImage
							v-model="profile.photo"
							class="mb-5 mr-0 sm:mr-8"
							@uploadPhoto="togglePhoto"
						/>
						<div class="vx-row max-w-sm sm:max-w-full">
							<div class="vx-col">
								<div class="vx-row">
									<div class="vx-col w-full md:w-1/2 mb-2">
										<vs-input
											v-validate="'required|min:3'"
											v-model="profile.first_name"
											:disabled="isLoading"
											:label="$t('personName')"
											name="name"
										/>
										<span
											:class="{
												'text-transparent':
													!errors.first('name'),
											}"
											class="text-danger text-sm"
										>
											{{ $t("fieldFilledIncorrect") }}
										</span>
									</div>
									<div
										class="vx-col w-full md:w-1/2 mb-2 w-full order-last md:order-normal"
									>
										<vx-input-group>
											<vs-password
												v-model="oldpassword"
												v-validate="'min:6|max:32'"
												:label="$t('password')"
												:disabled="isLoading"
												data-vv-validate-on="blur"
												type="password"
												ref="oldpassword"
												name="oldpassword"
												toggleCommand="oldpassword"
												@toggleShow="toggleShow"
											/>
										</vx-input-group>
										<span
											:class="{
												'text-transparent':
													!errors.first(
														'oldpassword'
													),
											}"
											class="text-danger text-sm"
										>
											{{ $t("fieldFilledIncorrect") }}
										</span>
									</div>
									<div class="vx-col w-full md:w-1/2 mb-2">
										<vs-input
											v-model="profile.last_name"
											v-validate="'required|min:3'"
											:label="$t('surname')"
											:disabled="isLoading"
											name="surname"
										/>
										<span
											:class="{
												'text-transparent':
													!errors.first('surname'),
											}"
											class="text-danger text-sm"
										>
											{{ $t("fieldFilledIncorrect") }}
										</span>
									</div>
									<div
										class="vx-col w-full md:w-1/2 mb-2 w-full order-last md:order-normal"
									>
										<vx-input-group>
											<vs-password
												v-model="newpassword"
												v-validate="'min:6|max:32'"
												:label="$t('repeatPassword')"
												:disabled="isLoading"
												data-vv-validate-on="blur"
												type="password"
												ref="newpassword"
												name="newpassword"
												toggleCommand="newpassword"
												@toggleShow="toggleShow"
											/>
										</vx-input-group>
										<span
											:class="{
												'text-transparent':
													!errors.first(
														'newpassword'
													),
											}"
											class="text-danger text-sm"
										>
											{{ $t("fieldFilledIncorrect") }}
										</span>
									</div>

									<div class="vx-col w-full md:w-1/2 mb-2">
										<vs-input
											v-validate="'required|email|min:3'"
											v-model="profile.email"
											:disabled="isLoading"
											label="E-Mail"
											name="email"
										/>
										<span
											:class="{
												'text-transparent':
													!errors.first('email'),
											}"
											class="text-danger text-sm"
										>
											{{ $t("fieldFilledIncorrect") }}
										</span>
									</div>
								</div>
							</div>
						</div>
					</div>
					<div class="flex flex-end flex-wrap mb-3 my-5">
						<vs-button
							class="mr-5"
							:disabled="isLoading"
							@click="editAccountant"
						>
							{{ $t("save") }}
						</vs-button>
						<vs-button
							color="warning"
							type="border"
							@click="$router.go(-1)"
						>
							{{ $t("cancel") }}
						</vs-button>
					</div>
				</vx-card>
			</div>
		</div>
	</div>
</template>

<script>
import ProfileImage from "@/components/ProfileImage";
import vSelect from "vue-select";
import datepicker from "vuejs-datepicker";
import notifier from "../../mixins/notifier";

export default {
	name: "EditAccountant",
	mixins: [notifier],
	components: {
		ProfileImage,
		datepicker,
		"v-select": vSelect,
	},

	data() {
		return {
			popupActive: false,
			val: "",
			description: "",
			name: "",
			email: "",
			emailRent: "",
			surname: "",
			date: "",
			phone: "",
			sex: "",
			country: "",
			about: "",
			oldpassword: "",
			newpassword: "",
			lang: [],
			subject: [],
			isEditingLogo: false,

			profile: {},
			isLoading: false,
		};
	},

	async created() {
		this.profile = (await this.$http.get("/accountant/profile")).data.data;
	},

	methods: {
		async togglePhoto(err, file) {
			try {
				this.profile.photo = (
					await this.$http.post(
						"/upload/one",
						this.$formData({ file: file[0] })
					)
				).data.data.url;
				this.isEditingLogo = false;
			} catch (e) {
				this.notifyError(e.message);
			}
		},

		async editAccountant() {
			try {
				this.isLoading = true;

				let formData = Object.assign({}, this.profile);

				if (this.newpassword !== "" && this.newpassword !== null) {
					formData.password = this.newpassword;
				}
				if (this.oldpassword !== "" && this.oldpassword !== null) {
					formData.password2 = this.oldpassword;
				}

				this.newpassword = null;
				this.oldpassword = null;

				let res = (
					await this.$http.post(
						"/accountant/profile/update",
						this.$formData(formData)
					)
				).data.data;

				this.notifySuccess(this.$t("dataIsSaved"));

				await this.$store.dispatch("updateUserInfo", res);
				this.$router.back();
			} catch (e) {
				this.notifyError(e.message);
				if (e.errors) {
					Object.values(e.errors).forEach((err) => {
						this.notifyError(err);
					});
				}
			} finally {
				this.isLoading = false;
			}
		},

		async removePhoto() {
			try {
				let res = await this.$http.post(
					"/accountant/profile/delete-photo"
				);
				this.notifySuccess(this.$t("dataIsSaved"));
			} catch (e) {
				this.notifyError(e.message);
			}
		},

		toggleShow(ref) {
			let input = this.$refs[ref].$el.querySelector("input");
			input.type = input.type === "password" ? "text" : "password";
		},
	},
};
</script>

<style lang="scss">
@import "../../assets/scss/vuexy/variables";
@import "../../assets/scss/vuexy/functions";

.edit-admin-profile {
	.vx-input-group .append-text.btn-addon .vs-button {
		height: 2.65rem;
		width: 2.65rem;
		justify-content: center;
		padding: 0 !important;
		margin-top: 20px;
		align-items: center;

		&-text {
			margin-top: 4px;
		}
	}

	.vs-con-input-label {
		width: 100%;
	}

	h1 {
		font-size: 18px;
		color: #626262;
		margin-bottom: 15px;
		font-weight: 700;
	}

	table {
		margin-bottom: 20px;
		padding-left: 15px;

		tr {
			td {
				padding-bottom: 7px;

				&:first-child {
					width: 250px;
					font-weight: 600;
				}
			}
		}
	}

	.photo {
		width: 170px;
		height: 150px;
		border-radius: 10px;
		overflow: hidden;
		margin: 15px 0;
		margin-right: 35px;
		flex-shrink: 0;
		.con-input-upload,
		.img-upload {
			width: 100%;
			margin: 0;
			height: 100%;
		}
		.con-img-upload {
			height: 100%;
		}
		.con-upload {
			height: 100%;
		}
		img {
			max-width: 100%;
			margin: 0 auto;
			width: 100%;
			height: 100%;
		}
	}

	.info {
		width: 170px;
		flex-shrink: 0;
		align-items: center;
		justify-content: center;
		margin-right: 30px;
	}

	.box {
		display: flex;
		font-size: 25px;
		align-items: center;
		margin-bottom: 22px;
	}

	.bottom {
		display: flex;
		justify-content: flex-end;
	}
}
</style>
